import { Permission } from '@src/main/modules/roles/domain/permission.interface';
import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RoleForm.module.scss';

interface RoleFormProps {
  values: {
    role: string;
    description: string;
    permissions: string[];
  };
  availablePermissions: Permission[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChange: (field: keyof RoleFormProps['values'], value: any) => void;
  handlePermissionChange: (r: string, e: CheckboxChangeEvent) => void;
  errors?: Record<string, string>;
}

const RoleForm: FC<RoleFormProps> = ({
  values,
  availablePermissions,
  handleChange,
  handlePermissionChange,
  errors,
}) => {
  const { t } = useTranslation();

  return (
    <form>
      <div className={styles.grid}>
        <FloatLabelInput
          label={t('rolesManagement.role')}
          value={values.role}
          onChange={(val) => handleChange('role', val)}
          error={errors?.role}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />
      </div>
      <div className={styles.grid}>
        <FloatLabelInput
          label={t('rolesManagement.description')}
          value={values.description}
          onChange={(val) => handleChange('description', val)}
          error={errors?.description}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />
      </div>
      <div className={`${styles.field} col-12 mt-4`}>
        <h4 className="mt-0">{t('rolesManagement.permissions')}</h4>
        <div className="grid">
          {availablePermissions.map((p) => (
            <div className="field-checkbox col-12" key={p.permissionId}>
              <Checkbox
                inputId={`cb-${p.permissionId}`}
                value={p.permissionId}
                onChange={(e) => handlePermissionChange(p.permissionId, e)}
                checked={values.permissions.includes(p.permissionId)}
              />
              <label htmlFor={`cb-${p.permissionId}`}>{p.description}</label>
            </div>
          ))}
        </div>
      </div>
    </form>
  );
};

export default RoleForm;
